/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { useGetBalanceAccounts } from "../../service/adyen-account-holders-api";
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { EmptyState } from "../../../../components/EmptyState";
import { PageFooter } from "../../../../components/page-skeleton/PageFooter";
import { StyledText } from "../../../../assets/typography/typography";
import { SpinnerBlock } from "../../../common/Spinner";
import { routes } from "../../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { AdyenAccountHolderBalanceAccountsTable } from "./AdyenAccountHolderBalanceAccountsTable";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const AdyenAccountHolderBalanceAccounts = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: balanceAccounts, isLoading } = useGetBalanceAccounts(id);

  if (isLoading || !balanceAccounts) {
    return <SpinnerBlock />;
  }

  return (
    <CardContainer>
      <PageHeader
        title="Balance accounts"
        subtitle="Manage all of your balance accounts for this account holder"
      >
        <ButtonInternalLink
          to={routes.adyenAccountHolderBalanceAccountsNew(
            organizationKeyName,
            id
          )}
        >
          Create new balance account
        </ButtonInternalLink>
      </PageHeader>
      {balanceAccounts.length === 0 ? (
        <>
          <Divider />
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No balance accounts created yet"
              subtitle="Click in the top right corner to create your first new balance account."
            />
          </CardBody>
        </>
      ) : (
        <div>
          <AdyenAccountHolderBalanceAccountsTable
            balanceAccounts={balanceAccounts}
          />
          <PageFooter>
            <StyledText className="bodyTextRegular mb-0">
              {balanceAccounts.length}{" "}
              {balanceAccounts.length === 1
                ? "balance account"
                : "balance accounts"}{" "}
              in total
            </StyledText>
          </PageFooter>
        </div>
      )}
    </CardContainer>
  );
};
